import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { cn } from "../utils/cn";
import { NavLink } from 'react-router-dom';
import { navbarLinks } from '../Components/NavbarLinks';
import { Database } from 'lucide-react';

export const SideBar = forwardRef(({ collapsed }, ref) => {
  return (
    <aside
      ref={ref}
      className={cn(
        "fixed z-[100] flex h-full w-[240px] flex-col overflow-x-hidden border-r border-gray-800 bg-[#141414] transition-[width,left,background-color,border] duration-300 ease-in-out",
        collapsed ? "md:w-[70px] md:items-center" : "md:w-[240px]",
        collapsed ? "max-md:-left-full" : "max-md:left-0"
      )}
    >
      {/* Logo Section */}
      <div className="p-6 border-b border-gray-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0">
  <img
    src="/logo.png"
    alt="Vector Migration Logo"
    className="w-6 h-6 object-contain"
  />
</div>

          {!collapsed && (
            <span className="text-xl font-bold text-white whitespace-nowrap">
              VectorMigration
            </span>
          )}
        </div>
      </div>

      {/* User Info Section */}
      <div className="p-6 border-b border-gray-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-gray-500 to-gray-700 rounded-full flex items-center justify-center text-sm font-semibold text-white flex-shrink-0">
            DF
          </div>
          {!collapsed && (
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-white truncate">Dular</div>
              <div className="text-xs text-gray-400 truncate">dular@example.com</div>
              <div className="text-xs text-gray-500 mt-1">Premium Tier</div>
            </div>
          )}
        </div>
      </div>

      {/* Navigation Section */}
      <div className="flex w-full flex-col gap-y-4 overflow-y-auto overflow-x-hidden p-4 flex-1 [scrollbar-width:_thin]">
        {navbarLinks.map((navbarLink) => (
          <nav
            key={navbarLink.title}
            className={cn("flex flex-col gap-y-1", collapsed && "md:items-center")}
          >
            {!collapsed && (
              <p className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {navbarLink.title}
              </p>
            )}
            {navbarLink.links.map((link) => (
              <NavLink
                key={link.label}
                to={link.path}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200",
                    isActive
                      ? "bg-gray-500/20 text-gray-200"
                      : "text-gray-400 hover:bg-gray-800/50 hover:text-white",
                    collapsed && "md:w-[45px] md:justify-center"
                  )
                }
              >
                <link.icon size={20} className="flex-shrink-0" />
                {!collapsed && (
                  <span className="font-medium whitespace-nowrap">{link.label}</span>
                )}
              </NavLink>
            ))}
          </nav>
        ))}
      </div>
    </aside>
  );
});

SideBar.displayName = "SideBar";
SideBar.propTypes = {
  collapsed: PropTypes.bool,
};